export default {
  // Ana sayfadaki ana hero bloğu
  title_1: 'Uluslararası Gayrimenkul Değerlendirme Platformu',
  title_2: 'Piyasa fiyatının altında gayrimenkul bulun',
  lead_1: 'Yapay zeka ile değerlendirme, tahmin ve karşılaştırma — hepsi tek bir yerde',
  lead_2: 'Modern algoritmalar: Doğrusal regresyon, rastgele orman, sinir ağı',
  lead_3: 'Yatırımcılar, müteahhitler, ajanslar ve emlak satıcıları için',
  login_btn: 'Giriş yap',

  // Diğer sayfaların hero başlıkları
  title_property: 'Gayrimenkul',
  title_properties: 'Gayrimenkul Kataloğu',
  title_developer: 'Müteahhit Profili',
  title_developers: 'Tüm Müteahhitler',
  title_agency: 'Ajans Profili',
  title_agencies: 'Emlak Ajansları',
  title_news: 'Haberler ve Analiz',
  title_news_item: 'Haber Detayları',
  title_residential_complex: 'Konut Projesi',
  title_district: 'Bölge Hakkında Bilgi',
  title_statistics: 'Piyasa İstatistikleri',
  title_about: 'Estimator24 Hakkında',

  // Breadcrumbs
  breadcrumbs: {
    home: 'Ana Sayfa',
    properties: 'Tüm İlanlar',
    developers: 'Müteahhitler',
    agencies: 'Ajanslar',
    news: 'Haberler',
    statistics: 'İstatistikler',
    about: 'Proje Hakkında'
  }
}
